class DealSheetConfigurationMapper {
  processSalesCenterFormToDealRules(formData: Record<string, any>): Record<string, any> {
    return {
      location: formData.location ? formData.location : null,
      saleType: formData.saleType ? formData.saleType : null,
      paymentType: formData.paymentType ? formData.paymentType : null,
      equipmentType: formData.equipmentType ? formData.equipmentType : null,
    };
  }
}

export const dealSheetConfigurationMapper = new DealSheetConfigurationMapper();
